// V1.14 White-Label: zentrale Ableitung der Logo-`src` für das Branding-Logo.
// Sicherster Pfad = immer als <img> rendern. Data-URLs werden direkt durchgereicht,
// rohe SVG-Strings per data:image/svg+xml;charset=utf-8,<encoded> eingebettet —
// NIEMALS dangerouslySetInnerHTML. Diese XSS-relevante Kodierung lebt bewusst an
// EINER Stelle (statt dupliziert in AppShell/OtpLogin), damit sie nicht auseinanderdriftet.
export function brandingLogoSrc(logo: string | null | undefined): string | null {
  if (!logo) return null
  return logo.startsWith('data:')
    ? logo
    : `data:image/svg+xml;charset=utf-8,${encodeURIComponent(logo)}`
}
